export function scrollToTargetCenter(targetElement: HTMLElement, parentElement: HTMLElement): void {
  const offset =
    targetElement.offsetLeft - parentElement.clientWidth / 2 + targetElement.clientWidth / 2;

  parentElement.scrollTo({
    left: offset,
    behavior: 'smooth'
  });
}
